// extracted by mini-css-extract-plugin
export var gif = "_k1-0";